import React, { FC } from "react"
import "./index.scss"
type TBlockTitleProps = {
  title: string
  lineColor?: string
  bgColor?: string
  onClose?: any
  closable?: boolean
}
const BlockTitle: FC<TBlockTitleProps> = ({
  title,
  lineColor = "#00FFFB",
  bgColor = "rgba(0, 255, 251, 0.28)",
  closable,
  onClose,
}) => {
  return (
    <div className="b-title" style={{ borderColor: lineColor }}>
      <div className="title" style={{ backgroundColor: bgColor }}>
        {title}
        {closable && (
          <span
            className="close"
            onClick={() => {
              onClose && onClose()
            }}
          ></span>
        )}
      </div>
      <div className="tail">
        <span style={{ backgroundColor: bgColor }}></span>
        <span style={{ borderTopColor: bgColor }}></span>
      </div>
    </div>
  )
}
export default BlockTitle
